import { render, staticRenderFns } from "./enquiryDetailCom.vue?vue&type=template&id=46fa1462&scoped=true"
import script from "./enquiryDetailCom.vue?vue&type=script&lang=js"
export * from "./enquiryDetailCom.vue?vue&type=script&lang=js"
import style0 from "./enquiryDetailCom.vue?vue&type=style&index=0&id=46fa1462&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46fa1462",
  null
  
)

export default component.exports